import { useState, useMemo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
// import "../../../assets/css/slotplaning/new_slot/newslot.scss";
import LeftMenu from "../../../Components/Layout/LeftMenu";
import Header from "../../../Components/Layout/Header";

import { ReactComponent as DriverIcon } from "../../../assets/images/sidebar/driver.svg";
import { ReactComponent as VisitorIcon } from "../../../assets/images/sidebar/visitor.svg";
import { ReactComponent as AtIcon } from "../../../assets/images/sidebar/alltrips.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/images/sidebar/settings.svg";
import { ReactComponent as SC } from "../../../assets/images/settings_icon/slotsettings.svg";
import { ReactComponent as RS } from "../../../assets/images/settings_icon/resourcesettings.svg";
import Trips from "./Components/Trips";
import Visitor from "./Components/Visitor";
import ShiftReport from "./Components/ShiftReport";
import ShiftDetails from "./Components/ShiftDetails";
import Settings from "../../Settings/SettingsNew";
import SubDriver from "./Components/SubDriver";
import SubVisitor from "./Components/SubVisitor";
import { useUserCheckQuery } from "../../../redux/services/Auth";

const Security = () => {
    const initialTab = localStorage.getItem("MainTab");
    const initPage = localStorage.getItem("InnerPage") || '';
    const tabs = ['TRP', 'SR', 'AR', 'ST'].includes(initialTab);

    const [mainTab, setMainTab] = useState(tabs ? initialTab : 'TRP');
    const initialSub = localStorage.getItem("SubTab");
    const [subTab, setSubTab] = useState(initialSub || '');
    const initTitle = { title: 'Security' }
    const [sendHeader, setSendHeader] = useState(initTitle);
    const [innerPage, setInnerPage] = useState(initPage);

    const [isIconClosed, setIsIconClosed] = useState(true);
    const [userDetails, setUserDetails] = useState();

    const sections = ['main', 'report', 'settings'];
    const navItems = {
        home: true,
        main: [
            { path: 'TRP', name: 'Trips', heading: 'Trips', icon: <DriverIcon className='menu-icon' /> },
            // { path: 'VSR', name: 'Visitor', heading: 'Visitor', uc: true, icon: <VisitorIcon className='menu-icon' /> },
            { path: 'SR', name: 'Shift Report', heading: 'Shift Report', icon: <AtIcon className='menu-icon' /> },
            {
                path: 'AR', name: 'Access Registration', heading: 'Access Registration', icon: <VisitorIcon className='menu-icon' />,
                sub: [
                    { path: 'DV', name: 'Driver', heading: 'Driver', default: true },
                    { path: 'VS', name: 'Visitor', heading: 'Visitor', },
                ]
            },
        ],
        // report: [
        //     { path: 'KC', name: 'KPI Charts', icon: <ChartIcon className='menu-icon' /> },
        //     { path: 'EXP', name: 'Export', icon: <ExdIcon className='menu-icon' /> },
        // ],
        settings: [
            { path: 'ST', name: 'Settings', heading: 'Settings', icon: <SettingsIcon className='menu-icon' /> },
            // { path: 'ML', name: 'Manual', icon: <ManualIcon className='menu-icon' /> },
        ]
    };

    const settingsNav = [
        {
            name: 'Shift Report',
            items: [
                { name: 'General', path: '#', icon: <SC />, tab: 'sec_gen', default: true },
                { name: 'Device Settings', path: '#', icon: <SC />, tab: 'sec_dev', default: true },
                { name: 'Assets', path: '#', icon: <SC />, tab: 'sec_ast', },
                { name: 'Groups', path: '#', icon: <RS />, tab: 'sec_grp', },
            ]
        }
    ];
    const handleCollapse = (value) => {
        setIsIconClosed(value);
    };

    useEffect(() => {
        // const findRow = navItems?.main?.main?.find(i => i.path === mainTab)
        const findRow = sections.flatMap(sections => navItems?.[sections] || []).find(i => i.path === mainTab)
        setSendHeader({
            ...initTitle,
            subTitle: findRow?.heading || findRow?.name
        });

    }, [])

    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
      });
    useEffect(() => {
        if (myData?.response_data) {
            setUserDetails(myData?.response_data);
        }
    }, [myData]);

    const handleNavClick = (main = null, page = '', extraInfo) => {
        // if (['IM', 'EX', 'UL', 'ML'].includes(main)) {
        //   toast.warning('Page is under construction!');

        // } else {

        // if (page) {
        //     setInnerPage(page);
        //     localStorage.setItem('InnerPage', page);
        // }
        if (page) {
            setInnerPage(page);
            localStorage.setItem('InnerPage', page);
            localStorage.setItem('DetailsTitle', extraInfo);
            setSendHeader({
                ...initTitle,
                subTitle: page === 'SD' ? 'Shift Report' : '',
                extraInfo: extraInfo,
            });
        }
        if (main) {
            setInnerPage('');
            localStorage.setItem('InnerPage', '');
            localStorage.removeItem('DetailsTitle');

            setMainTab(main.path);
            if (main.sub) {
                if (!initialSub) {
                    const findDefault = main?.sub?.find(i => i.default)
                    setSubTab(findDefault?.path)
                    localStorage.setItem('SubTab', findDefault?.path)
                    // setSubHead(findDefault?.heading)
                    setSendHeader({
                        ...initTitle,
                        subTitle: findDefault?.heading
                    });
                } else {
                    setSubTab(initialSub)
                }
            } else {
                const findRow = sections.flatMap(sections => navItems?.[sections] || []).find(i => i.path === main.path)
                // setSubHead(findRow?.heading || findRow?.name)
                setSendHeader({
                    ...initTitle,
                    subTitle: findRow?.heading || findRow?.name
                });
            }

            // const findRow = sections.flatMap(sections => navItems?.[sections] || []).find(i => i.path === main.path)
            // setSendHeader({
            //     ...initTitle,
            //     subTitle: findRow?.heading || findRow?.name
            // });

            localStorage.setItem('MainTab', main.path);
        }
    }
    const handleSubNav = (snav) => {
        // console.log('snav', snav);
        if (snav) {
            setSubTab(snav?.path)
            localStorage.setItem('SubTab', snav?.path)
            // setSubHead(snav?.heading)
            setSendHeader({
                ...initTitle,
                subTitle: snav?.heading
            });
        }
    }

    return (
        <>
            <div className="d-flex">
                <LeftMenu userInfo={userDetails} isIconClosed={isIconClosed} selTab={mainTab} navs={navItems} onNav={handleNavClick} onSubNav={handleSubNav} />
                <div className="mainbody-right">
                    <Header userInfo={userDetails} isIconClosed={isIconClosed} oncollapsed={handleCollapse} propData={sendHeader} />

                    <div className="">
                        {innerPage === '' &&
                            <>
                                {mainTab === 'TRP' && <Trips />}
                                {/* {mainTab === 'VSR' && <Visitor />} */}
                                {mainTab === 'SR' && <ShiftReport onNav={handleNavClick} />}
                                {mainTab === 'ST' && <Settings onSnav={settingsNav} />}
                                {mainTab === 'AR' &&
                                    <>
                                        {subTab === 'DV' && <SubDriver />}
                                        {subTab === 'VS' && <SubVisitor />}
                                    </>
                                }
                            </>
                        }
                        {innerPage === 'SD' && <ShiftDetails />}
                    </div>
                </div>
            </div >
        </>
    )
}

export default Security;